module.exports = __webpack_public_path__ + "static/media/calendar-arrow-left.e2e09636.svg";